export const CONSTANTS = {
  headerHeight: 6,
  bodyHeight: 85,
  tabNavigatorHeight: 9,
  lightModeBg: 'bg-[#f2f2f7]',
  darkModeBg: 'dark:bg-black',
};
